(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uc-large-vehicle-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('uc-large-vehicle-checkout');
  if (!template) return;
  const allLarge = template.dataset.allLarge === 'true';
  let applied = false;
  let timer;
  let observer;
  const labelShipping = (root) => {
    if (!allLarge) return;
    root.querySelectorAll('.checkoutMethodName').forEach((label) => {
      if (label.textContent.trim() === 'Shipping') {
        label.textContent = template.dataset.deliveryLabel;
      }
    });
  };
  const mount = () => {
    const root = document.getElementById('storePickupApp');
    const api = window.Zapiet;
    if (!root || !root.querySelector('.checkoutMethodsContainer .checkoutMethod') || !api || typeof api.show !== 'function' || typeof api.hide !== 'function') return;
    if (applied) return;
    applied = true;
    if (!document.getElementById('uc-large-vehicle-note')) root.before(template.content.cloneNode(true));
    if (allLarge) {
      api.show('shipping');
      api.show('pickup');
      api.hide('delivery');
    } else {
      api.show('pickup');
      api.hide(['shipping', 'delivery']);
    }
    labelShipping(root);
    observer = new MutationObserver(() => labelShipping(root));
    observer.observe(root, { childList: true, subtree: true });
    if (timer) clearInterval(timer);
  };
  mount();
  if (!applied) timer = setInterval(mount, 100);
  setTimeout(() => { if (timer) clearInterval(timer); }, 30000);
  window.addEventListener('pagehide', () => {
    if (timer) clearInterval(timer);
    if (observer) observer.disconnect();
  }, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
